import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';

export interface IFixedPriceUserEntityAttributes extends IModelAttributes {
	email: string;
	userName: string;
	twoFactorEnabled: boolean;
}
@entity('FixedPriceUserEntity', 'Fixed Price User')
export default class FixedPriceUserEntity extends Model implements IFixedPriceUserEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = ['email', 'userName', 'twoFactorEnabled'];

	@observable
	@attribute()
	public email: string;

	@observable
	@attribute()
	public twoFactorEnabled: boolean;

	@observable
	@attribute()
	public userName: string;

	@observable
	public password: string;

	@observable
	public _confirmPassword: string;

	constructor(attributes?: Partial<IFixedPriceUserEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IFixedPriceUserEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.email !== undefined) {
				this.email = attributes.email;
			}
			if (attributes.userName !== undefined) {
				this.userName = attributes.userName;
			}
			if (attributes.twoFactorEnabled !== undefined) {
				this.twoFactorEnabled = attributes.twoFactorEnabled;
			}
		}
	}
}
